import { Route, Routes, useLocation } from "react-router-dom";
import ProductListing from "./components/products/product-listing";
import NavBar from "./shared/navbar";
import ManageProducts from "./components/products/manage-products";
import { ToastContainer } from "react-toastify";
import Loader from "./shared/loader";
import Footer from "./shared/footer";
import AddOnsIndex from "./components/addOns/addOns-index";
import { useAuth } from "./contexts/auth-context";
import { observer } from "mobx-react";
import ManageOrders from "./components/orders/manage-orders";
import ManageCustomerOrders from "./components/orders/manage-orders-cust";
import ResetPassword from "./components/account/reset-password";
import NavBarBottom from "./shared/navbar-bottom";
import ShopSettings from "./components/shopSettings/shop-settings";
import UserProfile from "./components/users/user-profile";
import ManageDrivers from "./components/delivery/manage-drivers";
import HomePage from "./components/home/home-page";
import HomePageAdmin from "./components/home/home-page-admin";
import ManageAllergens from "./components/allergens/manage-allergens";
import ManageCategories from "./components/productCategories/manage-categories";
import ManageProductOffers from "./components/productOffers/manage-product-offers";
import ManageFinance from "./components/finance/manage-finance";
import UsersIndex from "./components/users/users-index";
import ManageVouchers from "./components/vouchers/manage-vouchers";

const AppRoutes = observer(() => {
  const { isAuthenticated, isShopAdmin, isShopUser, isMobileResolution } =
    useAuth();
  const { pathname } = useLocation();

  return (
    <>
      {pathname !== "/" && <NavBar />}
      {isMobileResolution && <NavBarBottom />}

      <Routes>
        <Route
          path="/"
          element={
            isShopAdmin || isShopUser ? (
              <HomePageAdmin isShopAdmin={isShopAdmin} />
            ) : (
              <HomePage />
            )
          }
        />
        <Route path="/tbl-orders" element={<ProductListing />} />
        {isAuthenticated ? (
          isShopAdmin || isShopUser ? (
            <>
              <Route path="/orders" element={<ManageOrders />} />
              <Route path="/manage-products" element={<ManageProducts />} />
              <Route path="/manage-addons" element={<AddOnsIndex />} />
              <Route path="/account" element={<UserProfile />} />
              <Route path="/manage-drivers" element={<ManageDrivers />} />
              <Route path="/manage-allergens" element={<ManageAllergens />} />
              <Route path="/manage-cats" element={<ManageCategories />} />
              <Route path="/manage-offers" element={<ManageProductOffers />} />
              <Route path="/manage-vouchers" element={<ManageVouchers />} />
              {isShopAdmin && (
                <>
                  <Route path="/manage-fin" element={<ManageFinance />} />
                  <Route path="/manage-users" element={<UsersIndex />} />
                  <Route path="/shop-settings" element={<ShopSettings />} />
                </>
              )}
            </>
          ) : (
            <>
              <Route path="/my-orders" element={<ManageCustomerOrders />} />
              <Route path="/orders" element={<ManageCustomerOrders />} />
              <Route path="/account" element={<UserProfile />} />
              <Route path="/prods" element={<ProductListing />} />
            </>
          )
        ) : (
          <>
            <Route path="/reset-pwd" element={<ResetPassword />} />
            <Route path="/prods" element={<ProductListing />} />
          </>
        )}
      </Routes>
      {!pathname.includes("/tbl-orders") && <Footer />}
      <ToastContainer />
      <Loader />
    </>
  );
});

export default AppRoutes;
